import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18 12.5V10a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M14 11V9a2 2 0 1 0-4 0v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 10.5V5a2 2 0 1 0-4 0v9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "HandMetal";
const HandMetal = memo(themed(Icon));
export {
  HandMetal
};
//# sourceMappingURL=hand-metal.js.map
